import { SearchStoreState } from "./types";
import { NAV_SEARCH_RESULT_GROUPS } from "../consts";

// // // //

/**
 * INITIAL_STATE
 * Defines the initial state for the Search Redux store
 */
export const INITIAL_STATE: SearchStoreState = {
    groups: NAV_SEARCH_RESULT_GROUPS,
    loading: true,
    initialFetchComplete: false,
    error: null,
};
